export default __webpack_public_path__ + "contentmodules/promote_contributor_seats_popup.1368704c.png";